export default (): { [key: string]: string } =>
  document.cookie.split("; ").reduce((prev: { [key: string]: string }, current) => {
    const [name, ...value] = current.split("=");
    prev[name] = value.join("=");
    return prev;
  }, {});
